import * as React from 'react';
import { Theme, ThemedStyles, useStyles } from 'ui/base/theme';
import baseStyles from './error_message.module.css';

type ErrorMessageStyles = {
  error: string;
};

const themedStyles: ThemedStyles<ErrorMessageStyles> = {
  [Theme.DAYLIGHT]: {
    error: baseStyles.daylightError,
  },
  [Theme.MIDNIGHT]: {
    error: baseStyles.midnightError,
  },
};

export type ErrorMessageProps = {
  message: string | undefined;
};

export const ErrorMessage = ({ message }: ErrorMessageProps) => {
  const styles = useStyles(themedStyles);
  if (message) {
    return (
      <div className={styles.error}>{message}</div>
    );
  }
  return null;
};